import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import { Select, Option, Input } from 'element-ui';


export default {
    name: 'EmailSender',
    props: {
        id: [Number, String]
    },
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [Input.name]: Input,
    },
    computed: {
        currentEmailOrigin() {
            var resultArray = this.emails.filter(x => x.enumValue == this.currentEmailEnumValue);
            if (resultArray && resultArray.length) {
                return resultArray[0];
            }
            return null;
        },
        isValidEmail() {
            return this.currentEmail &&
                this.currentEmail.toInput &&
                this.currentEmail.toInput.length &&
                this.currentEmail.toInput[0] &&
                this.currentEmail.subjectReplaced &&
                this.currentEmail.textReplaced;
        }
    },
    data() {
        return {
            isProcessing: false,
            emails: [],
            currentEmail: null,
            currentEmailEnumValue: 0,
        };
    },
    methods: {
        validate_email(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        handlerChangeTo() 
        {
            if (!this.currentEmail.toInput || !this.currentEmail.toInput.length) {
                this.currentEmail.toInput = [];
                return;
            }

            var initLength = this.currentEmail.toInput.length;
            var newInput = [];
            this.currentEmail.toInput.forEach(email => {
                if (this.validate_email(email)) {
                    newInput.push(email);

                    if (!this.currentEmail.toInputList.includes(email)) {
                        this.currentEmail.toInputList.push(email);
                    }
                }
            });

            this.currentEmail.toInput = newInput;
            if (initLength > this.currentEmail.toInput.length) {
                this.$showError("Entered value is not valid email address. Value is removed.")
            }
        },
        handlerChangeEmail() {
            this.currentEmail = { ...this.currentEmailOrigin };
            this.currentEmail.toInputList = this.currentEmail.toInput;
        },
        load() {
            var self = this;
            self.isProcessing = true;
            request.getDefaultEmails(self.id)
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.isSuccess) {
                        self.emails = response.body.outputData;
                        self.handlerChangeEmail();
                    }
                    else {
                        self.$showError(response && response.body && response.body.message ? response.body.message : null);
                    }
                },
                    error => {
                        self.isProcessing = false;
                        self.$showError();
                    })
        },
        send() {
            var self = this;
            if (!self.currentEmail) {
                self.$showError("Email can not be empty");
                return;
            }

            self.isProcessing = true;
            request.sendRaceEmail(self.id, {
                enumValue: self.currentEmail.enumValue,
                subjectReady: self.currentEmail.subjectReplaced,
                textReady: self.currentEmail.textReplaced,
                toInputReady: self.currentEmail.toInput
            })
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.isSuccess) {
                        self.$showSuccess();
                    }
                    else {
                        self.$showError(response && response.body && response.body.message ? response.body.message : null);
                    }
                },
                    error => {
                        self.isProcessing = false;
                        self.$showError();
                    }
                );
        },
        init() {
            this.load();
        }
    },
    mounted() {
        this.init();
    },
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/view-race/email-sender/email-sender.js